// extracted by mini-css-extract-plugin
export default {"uc":"uc"};